import { render, staticRenderFns } from "./TodoListPage.vue?vue&type=template&id=2051a416&scoped=true&"
import script from "./TodoListPage.vue?vue&type=script&lang=js&"
export * from "./TodoListPage.vue?vue&type=script&lang=js&"
import style0 from "./TodoListPage.vue?vue&type=style&index=0&id=2051a416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2051a416",
  null
  
)

export default component.exports